import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from '../../util/Api';

import {
  CREATE_SPARE_TRANSFER_ADVICE_SUCCESS,
  FETCH_ATA_NO_SUCCESS,
  FETCH_SPARE_PARTS_BY_QUERY_SUCCESS,
  FETCH_SPARE_TRANSFER_ADVICE_SUCCESS,
  GET_SPARE_TRANSFER_ADVICE_SUCCESS,
  GET_STA_COUNT_START,
  GET_STA_COUNT_SUCCESS,
  SAVE_SPARE_TRANSFER_ADVICE_QUERY,
} from '../../constants/ActionTypes';

import axios from 'util/Api';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_SPARE_TRANSFER_ADVICE_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_SPARE_TRANSFER_ADVICE_QUERY,
    query,
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_SPARE_TRANSFER_ADVICE_SUCCESS,
    data,
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_SPARE_TRANSFER_ADVICE_SUCCESS,
    data,
  };
};

export const fetchAssetsByQuerySuccess = ({data}) => {
  return {
    type: FETCH_SPARE_PARTS_BY_QUERY_SUCCESS,
    data,
  };
};

export const fetchAtaNoSuccess = ({data}) => {
  return {
    type: FETCH_ATA_NO_SUCCESS,
    data,
  };
};

export const fetchQuantityByQuery = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    let query = '';
    Object.entries(data).forEach(([key, value], index) => {
      if(Object.keys(data).length - 1 === index) {
        query += `${key}=${value}`
      } else {
        query += `${key}=${value}&`
      }
    });
    try {
      const response = await axios.get(`/spare-part-transaction/getQuantityByQuery?${query}`);
      dispatch(fetchSuccess());
      dispatch(fetchAssetsByQuerySuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchStaNo = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get('/spare-transfer-advice/getStaNo');
      dispatch(fetchSuccess());
      dispatch(fetchAtaNoSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {spareTransferAdvice} = store.getState();
      const {query} = spareTransferAdvice;
      const response = await axios.get(`/spare-transfer-advice?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {spareTransferAdvice} = store.getState();
      const {query} = spareTransferAdvice;
      const response = await axios.get(`/spare-transfer-advice/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      payload.documents && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = {...item};
        delete data.file;
        documentData.push(data);
      });

      formData.append('documentData', JSON.stringify(documentData));

      Object.keys(payload).forEach(key => {
        if(key === 'documents') {
          return;
        }

        if(key === 'from' || key === 'to' || key === 'approvedBy' || key === 'preparedBy' || key === 'spareParts') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }

        if(key === 'owner') {
          if(!payload[key]) {
            return;
          }
        }

        formData.append(key, payload[key]);
      });

      const response = await axios.post(`/spare-transfer-advice`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push('/spare-transfer-advice');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log('Error****:', error);
    }
  };
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {

      let formData = new FormData();

      const documentData = [];
      const documentIds = [];
      payload.documents.map((item, index) => {
        if(!item.file.path) {
          formData.append('files', item.file);
          let data = {...item};
          delete data.file;
          documentData.push(data);
        } else {
          documentIds.push(item._id);
        }
      });

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('documentIds', JSON.stringify(documentIds));

      Object.keys(payload).forEach(key => {
        if(key === 'documents') {
          return;
        }

        if(key === 'from' || key === 'to' || key === 'approvedBy' || key === 'preparedBy') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }

        formData.append(key, payload[key]);
      });


      await axios.put(`/spare-transfer-advice/${id}`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      history.push('/spare-transfer-advice');
      dispatch(getResource());
    } catch (error) {
      console.log('Error****:', error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/spare-transfer-advice/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/spare-transfer-advice/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getSTACount = (status = 'Open', payload = {}) => {
  return async dispatch => {
    dispatch(getSTACountStart());
    try {
      const response = await axios.post(`/spare-transfer-advice/sta-count/${status}`, payload);

      // console.log(response, payload);
      dispatch(getSTACountOk(response.data[0] || {}));
    } catch (error) {
      dispatch(getSTACountOk({totalSpares: 0, count: 0}));
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getSTACountOk = ({totalSpares, count}) => {
  return {
    type: GET_STA_COUNT_SUCCESS,
    totalSpares,
    count
  };
};

export const getSTACountStart = () => {
  return {
    type: GET_STA_COUNT_START
  };
};
